import { createInjectionKey as o } from "./highrise529.mjs";
const n = o("n-popover-body");
export {
  n as popoverBodyInjectionKey
};
